import React from 'react';
import { Link, graphql } from 'gatsby';
import RichTextRenderer from '~/components/Dynamic/RichTextRenderer';
import useStoryblok from '~/utils/storyblok-service';

import Layout from '~/components/Layout';
import Seo from '~/components/SEO';

export default function Legal({ data, location, pageContext }) {
  const otherPosts = data.otherLegalPosts.nodes.filter((p) => p.lang === data.storyblokEntry.lang);
  const story = useStoryblok(data.storyblokEntry, location);

  return (
    <Layout hideFooterCta locale={pageContext.locale}>
      <Seo {...story?.content?.seo} lang={story.lang} pageContext={pageContext} />

      <section>
        <div className="container my-20 md:my-32">
          <div className="flex flex-wrap items-start">
            <aside className="hidden flex-wrap sm:flex-nowrap w-full mb-12 lg:mb-0 md:w-3/12 lg:justify-evenly md:block md:sticky top-[150px]">
              {otherPosts?.length > 0 &&
                otherPosts.map((p) => (
                  <h4
                    key={`nav${p.full_slug}`}
                    className="mb-5 w-full sm:w-auto sm:mr-4 lg:mr-0 font-heading text-17px leading-[1.015em]"
                  >
                    <Link
                      to={`/` + p.full_slug}
                      dangerouslySetInnerHTML={{ __html: p.name }}
                      activeClassName="font-bold"
                      className="transition opacity-100 hover:opacity-50"
                    />
                  </h4>
                ))}
            </aside>
            <div className="w-full overflow-hidden md:w-9/12">
              <div className="max-w-36">
                <div className="mb-14">
                  <h1
                    className="mb-4 font-bold leading-none text-46px tracking-2 font-heading"
                    dangerouslySetInnerHTML={{ __html: data.storyblokEntry.name }}
                  />
                </div>
                <aside className="py-5 border-t overflow-scroll overscroll-contain border-b flex w-full mb-12 lg:mb-0 md:w-3/12 space-x-8 lg:justify-evenly md:hidden md:sticky top-[100px] whitespace-nowrap">
                  {otherPosts?.length > 0 &&
                    otherPosts.map((p) => (
                      <h4
                        key={`nav${p.full_slug}`}
                        className="w-full sm:w-auto sm:mr-4 lg:mr-0 font-heading text-17px leading-[1.015em] whitespace-nowrap"
                      >
                        <Link
                          to={`/` + p.full_slug}
                          dangerouslySetInnerHTML={{ __html: p.name }}
                          activeClassName="font-bold"
                          className="transition opacity-100 hover:opacity-50"
                        />
                      </h4>
                    ))}
                </aside>
                <div className="my-14">
                  <RichTextRenderer content={story.content.Content} />
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </Layout>
  );
}

export const query = graphql`
  query LegalPageQuery($id: String!) {
    storyblokEntry(id: { eq: $id }) {
      id
      name
      content
      lang
      full_slug
    }

    otherLegalPosts: allStoryblokEntry(filter: { field_component: { eq: "legal" } }) {
      nodes {
        id
        name
        lang
        full_slug
      }
    }
  }
`;
